// Bixbite Pricing Data - INR
// Exchange rate used: 1 USD ≈ 80 INR (update as needed)
export const pricingPlansINR = [
  {
    name: 'Raw Bixbite',
    inputPrice: '₹40',
    outputPrice: '₹80',
    icon: 'DiamondIcon',
    gradient: 'linear-gradient(135deg, #00796b 0%, #4db6ac 100%)',
    shadowColor: 'rgba(0, 121, 107, 0.3)',
    popular: false,
  },
  {
    name: 'Polished Bixbite',
    inputPrice: '₹80',
    outputPrice: '₹160',
    icon: 'StarIcon',
    gradient: 'linear-gradient(135deg, #004d40 0%, #00796b 100%)',
    shadowColor: 'rgba(0, 77, 64, 0.3)',
    popular: false,
  },
  {
    name: 'Radiant Bixbite',
    inputPrice: '₹200',
    outputPrice: '₹700',
    icon: 'AutoAwesomeIcon',
    gradient: 'linear-gradient(135deg, #0288d1 0%, #4fc3f7 100%)',
    shadowColor: 'rgba(2, 136, 209, 0.3)',
    popular: false,
  },
  {
    name: 'Flawless Bixbite',
    inputPrice: '₹300',
    outputPrice: '₹800',
    icon: 'WorkspacePremiumIcon',
    gradient: 'linear-gradient(135deg, #f9a825 0%, #ffd54f 100%)',
    shadowColor: 'rgba(249, 168, 37, 0.3)',
    popular: true,
  },
];

export const additionalPricingINR = [
  {
    category: 'One-Time Charges',
    items: [
      'Create Web Application: ₹80',
      'Create Mobile Application: ₹80',
      'Create RAG Application: ₹160',
    ],
  },
  {
    category: 'Hourly Hosting Charges',
    items: [
      'Web Hosting: ₹8/hour',
      'Mobile Hosting: ₹8/hour',
      'RAG Hosting: ₹8/hour',
      'Publish to Your Domain: ₹5/hour (in addition to hosting)',
    ],
  },
  {
    category: 'Per-Click Charges',
    items: [
      'Download Source Code: ₹80/click',
      'Push to GitHub: ₹80/click',
      'Download Mobile Build: ₹80/click',
      'Get API Details for RAG Application: free',
      'Create Mobile Build: ₹400/click',
      'Publish to App Store: ₹400/click',
      'Publish to Play Store: ₹400/click',
    ],
  },
  {
    category: 'Speech Services',
    items: [
      'Speech to Text: ₹500 per million tokens',
      'Text to Speech: ₹990 per million tokens',
    ],
  },
];

